module.exports = __webpack_public_path__ + "static/img/tb-message-circle.2c435b04.svg";